const CPMockBadge = () => (
  <span
    style={{
      background: '#fef3c7',
      color: '#92400e',
      padding: '2px 8px',
      borderRadius: '9999px',
      fontSize: '11px',
      fontWeight: 700,
      border: '1px solid #fcd34d',
    }}
  >
    DEMO DATA
  </span>
);

export default CPMockBadge;
